<div *ngIf="data() as dashboard; else loading" class="horizinns-container center">
    <div class="sales-dashboard-container">
        <div class="sales-dashboard-sidebar">
            <app-sales-id-card [agent]="dashboard.agent"></app-sales-id-card>

            <div class="sales-dashboard-counter">
                <mat-card>
                    <mat-card-content>
                        <span class="display-count" [appCountUp]="dashboard.agentPropertiesWithOwners?.properties?.length ?? 0" [duration]="1500">
                        </span>
                        <!-- <span style="font-size: 7rem; font-weight: 800; color: #0d508e;" [appCountUp]="400" [duration]="1500">
                        </span> -->
                        <span>
                            Property Conversions
                        </span>
                    </mat-card-content>
                </mat-card>

            </div>

            <div class="sales-dashboard-counter">
                <mat-card>
                    <mat-card-content>
                        <span class="display-count" >
                            {{ dashboard.referralPropertiesWithOwners?.properties?.length ?? '0' }}
                        </span>
                        <span>
                            Referred Agent Conversions
                        </span>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="sales-dashboard-counter">
                <mat-card>
                    <mat-card-content>
                        <span class="display-count" >
                            {{ referralUrlClicks }}
                        </span>
                        <span>
                            Referral URL Clicks
                        </span>
                    </mat-card-content>
                </mat-card>
            </div>

            <app-referral-url></app-referral-url>
            
            <app-agent-form-record></app-agent-form-record>
            
            <app-agent-w9-record></app-agent-w9-record>
            
        </div>
        <div class="sales-dashboard-content">

            <mat-card class="horizinns-card">
                <h3>Properties</h3>
                <mat-card-content>
                    <div class="user-property-list-table-container mat-elevation-z8">
                        <table mat-table [dataSource]="dashboard.propertyWithOwners.properties" class="full-width-table">
                            <ng-container matColumnDef="host">
                                <th mat-header-cell *matHeaderCellDef> Host </th>
                                <td mat-cell *matCellDef="let property"> 
                                    {{ property.propertyOwner?.firstName }} {{ property.propertyOwner?.lastName}} 
                                </td>
                            </ng-container>
    
                            <ng-container matColumnDef="address">
                                <th mat-header-cell *matHeaderCellDef> Address </th>
                                <td mat-cell *matCellDef="let property"> 
                                    {{ property?.address?.street ?? 'N/A' }} 
                                </td>
                            </ng-container>
    
                            <ng-container matColumnDef="city">
                                <th mat-header-cell *matHeaderCellDef> City </th>
                                <td mat-cell *matCellDef="let property"> 
                                    {{ property?.address?.city ?? '' }} 
                                </td>
                            </ng-container>
    
                            <ng-container matColumnDef="state">
                                <th mat-header-cell *matHeaderCellDef> State </th>
                                <td mat-cell *matCellDef="let property">
                                    {{ property?.address?.state ?? '' }}
                                </td>
                            </ng-container>
    
                            <ng-container matColumnDef="expires">
                                <th mat-header-cell *matHeaderCellDef> Expires </th>
                                <td mat-cell *matCellDef="let property"> 
                                    {{ property.publishedExpiresAt | date:'MM/dd/yyyy' }} 
                                </td>
                            </ng-container>
    
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>

                        <!-- <table mat-table [dataSource]="dashboard.agentPropertiesWithOwners.properties" class="full-width-table">
                            <ng-container matColumnDef="host">
                                <th mat-header-cell *matHeaderCellDef> Host </th>
                                <td mat-cell *matCellDef="let property"> 
                                    {{ property | propertyOwner | async }} 
                                </td>
                            </ng-container>
    
                            <ng-container matColumnDef="address">
                                <th mat-header-cell *matHeaderCellDef> Address </th>
                                <td mat-cell *matCellDef="let property"> 
                                    {{ property?.address?.street ?? 'N/A' }} 
                                </td>
                            </ng-container>
    
                            <ng-container matColumnDef="city">
                                <th mat-header-cell *matHeaderCellDef> City </th>
                                <td mat-cell *matCellDef="let property"> 
                                    {{ property?.address?.city ?? '' }} 
                                </td>
                            </ng-container>
    
                            <ng-container matColumnDef="state">
                                <th mat-header-cell *matHeaderCellDef> State </th>
                                <td mat-cell *matCellDef="let property">
                                    {{ property?.address?.state ?? '' }}
                                </td>
                            </ng-container>
    
                            <ng-container matColumnDef="expires">
                                <th mat-header-cell *matHeaderCellDef> Expires </th>
                                <td mat-cell *matCellDef="let property"> 
                                    {{ property.expirationDate | date:'MM/dd/yyyy' }} 
                                </td>
                            </ng-container>
    
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table> -->
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="horizinns-card">
                <h3>Referred Agents</h3>
                <mat-card-content>
                    <div *ngIf="referred() as agents; else loading">

                        <div *ngIf="agents.length === 0" class="no-data-message">
                            <mat-icon color="primary">group_add</mat-icon>
                            <p>No referred agents found. Start building your team to see them here!</p>
                        </div>

                        <div class="user-property-list-table-container mat-elevation-z8" *ngIf="agents.length > 0">

                            <table mat-table [dataSource]="referredDataSource" matSort class="full-width-table">
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                                    <td mat-cell *matCellDef="let agent"> 
                                        {{ agent.firstName }} {{agent.lastName}} 
                                    </td>
                                </ng-container>
        
                                <ng-container matColumnDef="agentId">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Agent ID </th>
                                    <td mat-cell *matCellDef="let agent"> 
                                        {{ agent.agentId ?? 'N/A' }} 
                                    </td>
                                </ng-container>
                                
                                <ng-container matColumnDef="phone">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Phone </th>
                                    <td mat-cell *matCellDef="let agent"> 
                                        {{ agent.phoneNumber ? (agent.phoneNumber | phone) : 'N/A' }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="email">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                                    <td mat-cell *matCellDef="let agent"> 
                                        {{ agent.email }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="location">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
                                    <td mat-cell *matCellDef="let agent"> 
                                        {{ agent.city }}, {{ agent.state }}
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="referredColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: referredColumns;"></tr>
                            </table>
                             
                            <mat-paginator
                                [pageSizeOptions]="[5, 10, 25, 100]"
                                aria-label="Select page of referred agents">
                            </mat-paginator>
                        </div>
                        
                    </div>
                </mat-card-content>
            </mat-card>

            
        </div>
    </div>
</div>

<ng-template #loading>
  <div class="skeleton-loader"></div> 
</ng-template>
